import Form from 'components/Profile/Insurance/Form';
import ViewGate from 'components/Profile/View/Gate';

const Insurance = () => {
  return (
    <ViewGate stepId="insurance">
      {(editProps) => <Form {...editProps} />}
    </ViewGate>
  )
}

export default Insurance;
